import React from "react";
import { ReactComponent as Star } from '../resources/images/star.svg';

function ratingStars({value, maxValue, onHover, onHoverEnd, onClick}) {
    const stars = [];
    
    for (let index = 0; index < maxValue; index++) {
        let isChecked = value != null && index < value;

        stars.push(
            <Star
                key={index}
                data-rating={index + 1}
                className={`cursor-pointer w-8 h-8 bg-transparent ${isChecked ? "fill-star-icon" : "empty-star-icon"}`}
                onMouseEnter={onHover}
                onMouseLeave={onHoverEnd}
                onClick={() => onClick(index+1)}
            />
        )
    }

    return stars;
}

export default class Rating extends React.Component {
    constructor() {
        super();
        this.state = {editingValue: null};
        this._hover = this._hover.bind(this);
        this._hoverEnd = this._hoverEnd.bind(this);
        this._clicked = this._clicked.bind(this);
    }

    render() {
        let ratingProps = {
            value: this.state.editingValue != null ? this.state.editingValue : this.props.value, 
            maxValue: this.props.maxValue
        };
        if (!this.props.disabled) {
            ratingProps.onHover = this._hover;
            ratingProps.onHoverEnd = this._hoverEnd;
            ratingProps.onClick = this._clicked;
        }
        return <div className="rating">{ratingStars(ratingProps)}</div>;
    }

    _hover(event) {
        this.setState({editingValue: event.target.getAttribute('data-rating')});
    }

    _hoverEnd(event) {
        this.setState({editingValue: null});
    }
    
    _clicked(ratingValue) {
        if (this.props.onRatingChanged != null) {
            this.props.onRatingChanged(ratingValue);
        }
    }
}